import { Instance, types } from "mobx-state-tree";
import { ChatItemType } from "../ChatItemType";
import { BaseChatItem } from "./BaseChatItem";

/**
 * Empty item, used for events/items that should not have a representation
 * in the UI but nevertheless exist in history for reference purposes
 */
export const EmptyChatItem = types.compose(
  BaseChatItem,
  types.model({
    type: types.literal(ChatItemType.Empty)
  })
);

export interface IEmptyChatItem extends Instance<typeof EmptyChatItem> {}
